import { modals } from '@mantine/modals';
import { IconExclamationCircle } from '@tabler/icons-react';
import { useInvoiceSelection } from 'app/Private/Clients/Detail/UnhandledInvoicesTab/use-invoice-selection';
import { DisputeReasonForm } from 'app/Private/Reasons/DisputeReasonForm/DisputeReasonForm';
import { iconProps } from 'components/icon-props';
import { tKeys, useTranslate } from 'locales/index';
import type { InvoiceAction, UnhandledInvoice } from 'modules/AtRisk/api/use-load-unhandled-client';
import type { ActionButtonDefinition } from '../use-build-action-buttons';
import { computeCommonProps, useBatchAction } from './common';
import { openUnhandledInvoiceSelectionModal } from './open-unhandled-invoice-selection-modal';

export function useMarkAsDisputed(): (
  action: InvoiceAction,
  invoices: Array<UnhandledInvoice>,
) => ActionButtonDefinition {
  const t = useTranslate();
  const batchAction = useBatchAction();
  const { selectedInvoiceIds } = useInvoiceSelection();

  return (action, invoices) => {
    // Confirm/refine the invoice selection before marking them as disputed
    const handler = () =>
      openUnhandledInvoiceSelectionModal({
        title: t(tKeys.DEBTOR.REACTION.SELECT_INVOICES),
        selectedInvoiceIds,
        invoices,
        actionType: 'mark_as_disputed',
        isFinalStep: true,
        onNext: ({ invoiceIds }) => {
          modals.closeAll();
          modals.open({
            size: 'sm',
            title: t(tKeys.MARK_AS_DISPUTED),
            children: (
              <DisputeReasonForm onSubmit={values => batchAction('dispute', invoiceIds, values)} />
            ),
          });
        },
      });

    return {
      icon: <IconExclamationCircle {...iconProps()} />,
      translationKey: tKeys.MARK_AS_DISPUTED,
      onClick: handler,
      ...computeCommonProps(action, invoices),
    };
  };
}
